import { render } from "./App.vue?vue&type=template&id=1c1d9253"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1c1d9253&lang=scss"

import exportComponent from "/home/deploy/2290059a64cb5b6694a8/Front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__